import { useTranslation } from 'react-i18next';

export default function CourseOverview() {
  const { t } = useTranslation();

  const rows: { labelKey: string; valueKey: string; accent?: boolean }[] = [
    { labelKey: 'coursesAdvanced.overview.rowDuration', valueKey: 'coursesAdvanced.overview.valueDuration' },
    { labelKey: 'coursesAdvanced.overview.rowHours', valueKey: 'coursesAdvanced.overview.valueHours' },
    { labelKey: 'coursesAdvanced.overview.rowPrice', valueKey: 'coursesAdvanced.overview.valuePrice', accent: true },
    { labelKey: 'coursesAdvanced.overview.rowSchedule', valueKey: 'coursesAdvanced.overview.valueSchedule' },
    { labelKey: 'coursesAdvanced.overview.rowFormat', valueKey: 'coursesAdvanced.overview.valueFormat' },
    { labelKey: 'coursesAdvanced.overview.rowCapacity', valueKey: 'coursesAdvanced.overview.valueCapacity' },
    { labelKey: 'coursesAdvanced.overview.rowTarget', valueKey: 'coursesAdvanced.overview.valueTarget' },
  ];

  return (
    <section className="relative py-16 md:py-20 bg-background-50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        {/* Section Header */}
        <div className="text-center mb-12">
          {String(t('coursesAdvanced.overview.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-4">
            {t('coursesAdvanced.overview.title')}
          </h2>
          <div className="gold-line mx-auto"></div>
        </div>

        {/* Table */}
        <div className="table-scroll overflow-hidden border border-background-200/80">
          <div className="overflow-x-auto">
            <table className="w-full min-w-[600px]">
              <thead>
                <tr className="bg-primary-900">
                  <th className="w-[180px] px-6 py-4 text-left text-[14px] text-accent-400 tracking-[0.1em] font-medium font-heading">
                    {t('coursesAdvanced.overview.colItem')}
                  </th>
                  <th className="px-6 py-4 text-left text-[14px] text-accent-400 tracking-[0.1em] font-medium font-heading">
                    {t('coursesAdvanced.overview.colContent')}
                  </th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row, index) => (
                  <tr
                    key={index}
                    className={`border-t border-background-200/60 ${
                      index % 2 === 0 ? 'bg-background-100/50' : 'bg-background-50'
                    }`}
                  >
                    <td className="px-6 py-4 text-[15px] text-foreground-500 tracking-[0.06em] font-label whitespace-nowrap">
                      {t(row.labelKey)}
                    </td>
                    <td className={`px-6 py-4 text-[16px] tracking-[0.04em] ${
                      row.accent
                        ? 'text-accent-700 font-medium'
                        : 'text-foreground-800'
                    }`}>
                      {row.accent
                        ? t('coursesAdvanced.overview.priceFormat').replace('{price}', t('coursesAdvanced.overview.valuePrice'))
                        : t(row.valueKey)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Note */}
        <p className="text-[13px] text-foreground-500 tracking-[0.04em] mt-5 text-center">
          {t('coursesAdvanced.overview.note')}
          <a href="/schedule" className="text-accent-600 hover:text-accent-500 underline underline-offset-2 transition-colors">
            {t('coursesAdvanced.overview.scheduleLink')}
          </a>
          {t('coursesAdvanced.overview.noteSuffix')}
        </p>
      </div>
    </section>
  );
}
